import { SquareSpace } from './../common/SquareSpace/square-space.component';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import {
  ArtistProduct, ArtistProductImage,
} from '../models/artistproduct.model';
import { ViewArtistProductResponse } from '../models/viewartistproductresponse.model';
import { ShareableProductLink } from './artist-portfolio-products/artist-portfolio-products.service';

@Injectable({
  providedIn: 'root',
})
export class ArtistProductsService extends ServiceBase {
  private api: string = '/ArtistProduct';
  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }


  public syncArtistproducts(
    wooCommerceAccountId: string | null,
    shopifyAccountId: string | null,
    isUserAddManuallyRates: boolean,
    productIds: string[],
    squareSpaceAccountInfo?: any,
  ): Observable<SyncProductsResponse> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/sync-products-to-integrated-plateforms';
    const url: string = environment.BASE_API_PATH + this.api + method;

    const body = {
      isUserAddManullyRates: isUserAddManuallyRates,
      woocommerceAccountId: wooCommerceAccountId,
      shopifyAccountId: shopifyAccountId,
      squareSpaceAccountInfo: squareSpaceAccountInfo,
      artistProductIds: productIds
    };
    // ✅ Payload console log
    console.log('📤 Sync API Payload:', JSON.stringify(body, null, 2));

    return this.http.post<SyncProductsResponse>(url, body, httpOptions);
  }

  public getArtistProducts(artistId: string, removeConsignedProducts: boolean): Observable<any[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/' + artistId + '/fetch/' + removeConsignedProducts;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<any[]>(url, httpOptions);
  }

  public getArtistProduct(artistId: string, artistProductId: string): Observable<ArtistProduct> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/' + artistId + '/product/' + artistProductId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ArtistProduct>(url, httpOptions);
  }

  public getProductDetail(productId: string): Observable<any> {
    var httpOptions = this.RequestHeaders();
    const method: string = `/fetch-product-detail/${productId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<any>(url, httpOptions);
  }

  public updateShareableLink(shareableLinkId: string, numberOfColumnToShow: number | null, isShowProfile: boolean): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/ArtistProductPortfolio';
    const method: string = '/UpdateShareableLink';
    const url: string = environment.BASE_API_PATH + api + method;
    const requestBody = {
      shareableLinkId: shareableLinkId,
      numberOfColumnToShow: numberOfColumnToShow,
      isShowProfile: isShowProfile,
    };
    return this.http.post<ResponseObject>(url, requestBody, httpOptions);
  }

  public ArtistShareAvailableProduct(shareableProductFormData: ShareableProductLink): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/save-shareable-products-to-generate-link';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, shareableProductFormData, httpOptions
    );
  }

  public getArtistProductforFiltering(): Observable<artistProduct[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch-artist-products';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<artistProduct[]>(url, httpOptions);
  }

  public saveGalleryDescription(
    artistId: string,
    artistProductId: string,
    descriptionData: GalleryDescriptionResponse
  ): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string =
      '/update-description/' + artistId + '/' + artistProductId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, descriptionData, httpOptions);
  }

  public viewArtistProductDetail(artistId: string, artistProductId: string): Observable<ViewArtistProductResponse> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/' + artistId + '/productDetail/' + artistProductId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ViewArtistProductResponse>(url, httpOptions);
  }

  public getArtistProductImages(artistId: string, artistProductId: string | null): Observable<ArtistProductImage[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/' + artistId + '/product/' + artistProductId + '/additional-images';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ArtistProductImage[]>(url, httpOptions);
  }

  public getArtistProductStatus(artistId: string, artistProductId: string): Observable<ProductsStatusFiltersType> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/' + artistId + '/product/' + artistProductId + '/status';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ProductsStatusFiltersType>(url, httpOptions);
  }

  public getArtistProductsSummaryResponse(artistId: string, requestData: ArtistProductsSummaryRequest): Observable<ArtistProductSummary[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/' + artistId + '/fetch/summary';
    const url: string = environment.BASE_API_PATH + this.api + method;
  
     const payload: any = {};

  // Add only when not null or undefined
  if (requestData.pageNumber !== null && requestData.pageNumber !== undefined)
    payload.pageNumber = requestData.pageNumber;

  if (requestData.pageSize !== null && requestData.pageSize !== undefined)
    payload.pageSize = requestData.pageSize;

    if (requestData.artTypeId) payload.artTypeId = requestData.artTypeId;
    if (requestData.productCategory) payload.productCategory = requestData.productCategory;
    if (requestData.productSeriesId) payload.productSeriesId = requestData.productSeriesId;
    if (requestData.galleryId) payload.galleryId = requestData.galleryId;
    if (requestData.status !== undefined && requestData.status !== null) payload.status = requestData.status;
    if (requestData.requestStatus !== undefined && requestData.requestStatus !== null) payload.requestStatus = requestData.requestStatus;
    if (requestData.connectionStatus !== undefined && requestData.connectionStatus !== null) payload.connectionStatus = requestData.connectionStatus;
    if (requestData.query || requestData.Query) payload.query = requestData.query || requestData.Query;
    return this.http.post<ArtistProductSummary[]>(url, payload, httpOptions).pipe(

    );
  }


  public getProductGlazes(productId: string): Observable<string[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/' + productId + '/glazes';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<string[]>(url, httpOptions);
  }

  public connectProductCoverImage(artistId: string, artistProductId: string | null, imageUrl: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/${artistId}/product/${artistProductId}/connect-cover`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, { CoverImageUrl: imageUrl }, httpOptions);
  }

  public connectUploadedImages(artistId: string, artistProductId: string | null, imageUrls: string[], isGalleryImg: boolean = false): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/${artistId}/product/${artistProductId}/connect-images`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(
      url,
      { ImageUrls: imageUrls, IsGalleryImg: isGalleryImg },
      httpOptions
    );
  }

  public saveArtistProduct(artistId: string, data: ArtistProduct): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/save/' + artistId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, data, httpOptions);
  }

  public updateArtistProductCoverPhoto(artistId: string, data: CoverPhotoResponse): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/updateCoverPhoto/';
    const url: string =
      environment.BASE_API_PATH + this.api + method + artistId;
    return this.http.post<ResponseObject>(url, data, httpOptions);
  }

  public deleteArtWork(artWorkId: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const url: string = environment.BASE_API_PATH + this.api + '/' + artWorkId;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public deleteImage(id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = `/${id}/delete-image`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public updateArtistProductRevenue(
    artistProductId: string,
    artistRevenue: number
  ): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/updateArtistRevenue/' + artistProductId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, artistRevenue, httpOptions);
  }

  public createRelevantProduct(artistProductId: string, noOfProducts: number
  ): Observable<ViewArtistProductResponse[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/Get-similar-products/' + artistProductId + '/' + noOfProducts;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ViewArtistProductResponse[]>(url, httpOptions);
  }

  public getSimilarLatestRecentlySoldProducts(artistId: string): Observable<ArtistProductResponse> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/Get-Latest-RecentlySold-products/' + artistId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ArtistProductResponse>(url, httpOptions);
  }

  public GetLatestRecentlySoldGalleryProducts(galleryId: string): Observable<ArtistProductResponse> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/Get-Latest-RecentlySold-Gallery-products/' + galleryId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ArtistProductResponse>(url, httpOptions);
  }
}

export class PlatformSyncResult {
  ResponseObject!: ResponseObject;
  SyncedProducts!: string[] | null;
  AlreadySyncedProducts!: string[] | null;
}

export class SyncProductsResponse {
  ResponseObject!: ResponseObject;
  Shopify?: PlatformSyncResult;
  WooCommerce?: PlatformSyncResult;
  SquareSpace?: PlatformSyncResult;
}

export interface Pagination {
  TotalCount: number;
  PageNumber: number;
  PageSize: number;
}

export interface Product {
  Id: string;
  SerialNumber: string;
  Name: string;
  ShortDescription?: string | null;
  ArtistId: string;
  Category?: string | null;
  SeriesId?: string | null;
  SeriesName?: string | null;
  ArtTypeName?: string | null;
  ArtTypeId?: string | null;
  ClayId?: string | null;
  ProductImgUrl: string;
  ArtistRevenue: number;
  RetailPrice: number;
  IsConsignedProduct: boolean;
  ConsignmentId: string;
  GalleryAcceptedDate: string;
  IsSold: boolean;
  SoldPrice?: number | null;
  SoldDate?: string | null;
  CreatedBy?: string | null;
  CreatedDate: string;
  GalleryId?: string | null;
  GalleryName?: string | null;
}

export interface ArtistProductResponse {
  LatestProducts: Product[];
  RecentlySoldProducts: Product[];
  FastestTurnOutProducts: Product[];
}

export class TotalRowCount {
  totalRowCount!: string;
}

export class GalleryDescriptionResponse {
  GalleryShortDescription!: string;
  GalleryLongDescription!: string;
  GallerySocialMediaDescription!: string;
}

export class ArtistProductsSummaryRequest {
  // Support both camelCase and PascalCase for backward compatibility
  ProductCategory?: string;
  ArtTypeId?: string;
  ProductSeriesId?: string;
  GalleryId?: string;
  Status?: any;
  RequestStatus?: any;
  ConnectionStatus?: any;
  Query?: string;

  // Preferred camelCase properties
  productCategory?: string;
  artTypeId?: string;
  productSeriesId?: string;
  galleryId?: string;
  status?: any;
  requestStatus?: any;
  connectionStatus?: any;
  query?: string;
  pageNumber?: number;
  pageSize?: number;
}

export class ConsignedProductsRequest {
  ArtistId?: string;
  ProductCategory?: string;
  ArtTypeId?: string;
  Status?: string;
  Query?: string;
}

export class artistProduct {
  Id!: string;
  SerialNumber!: string;
  Name!: string;
  ShortDescription!: null | string;
  ArtistId!: string;
  Category!: null | string;
  SeriesId!: null | string;
  SeriesName!: null;
  ArtTypeName!: null;
  ArtTypeId!: null | string;
  ClayId!: null | string;
  ProductImgUrl!: string;
  ArtistRevenue!: number;
  RetailPrice!: null;
  IsConsignedProduct!: boolean;
  ConsignmentId!: null;
  GalleryAcceptedDate!: null;
  IsSold!: boolean;
  SoldPrice!: null;
  SoldDate!: null;
  CreatedDate!: Date;
  GalleryId!: null;
  GalleryName!: null;
}

export class ArtistProductSummary {
  [x: string]: any;
  Id!: string;
  ArtistId!: string;
  Name!: string;
  Category!: string;
  SeriesId!: string;
  ClayId!: string;
  ProductImgUrl?: string;
  ResizedImageUrl?: string;
  ArtistRevenue!: number;
  ArtistShortDescription?: string;
  ArtistLongDescription?: string;
  ShortDescription?: string;
  LongDescription?: string;
  SelectedGlazes: string[] = [];
  RetailPrice?: number;
  IsConsignedProduct!: boolean;
  ConsignmentId!: string;
  GalleryAcceptedDate?: Date;
  IsSold!: boolean;
  SoldPrice!: number;
  SoldDate!: Date;
  GalleryId!: string;
  GalleryName!: string;
  CreatedDate!: Date;
  //Helper Property
  SeriesName!: string;
  ArtTypeId!: string;
  ArtTypeName!: string;
  ListedBeforeXDays?: number | undefined;
  AcceptedBeforeXDays?: number | undefined;
  SoldBeforeXDays?: number | undefined;
  FormattedArtistRevenue: string | null = null;
  requestSent!: boolean;
  buttonColorClass!: string;
  SerialNumber?: string;
  SkuId?: string;
  ArtistSocialMediaDescription?: string;
  Length?: number;
  Width?: number;
  Height?: number;
  Weight?: number;
  IsActive?: boolean;
  isConsigned?: boolean | null;
  Series?: string;
  Material?: string;
  SeriesDto?: any;
  ClayDto?: any;
  CategoryDto?: any;
  ArtTypeDto?: any;
  ProductGlazeDto?: any;
  SquarePosProductId!: string;
  ShopifyProductId!: string;
  WooCommerceProductId!: string;
  WixProductId!: string;
  ProductSoldPrice?: number;
  IsProductSold?: boolean;
  IsSyncToWooCommerce?: boolean;
  IsSyncToShopify?: boolean;

  // Add this property for pagination info
  Pagination?: Pagination;
}

export class CoverPhotoResponse {
  ProductId!: string;
  CoverImageUrl!: string;
}

export enum ProductsStatusFilters {
  Default = 'Default',
  Available = 'Available',
  Consigned = 'Consigned',
  Sold = 'Sold',
}

export type ProductsStatusFiltersType =
  | ProductsStatusFilters.Default
  | ProductsStatusFilters.Available
  | ProductsStatusFilters.Consigned
  | ProductsStatusFilters.Sold;